import "./SelectPage.scss";
import { useLocation, useNavigate } from "react-router-dom";
import WhiteBtnB from "../../Atoms/Buttons/WhiteBtnB";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { useEffect, useState } from "react";
import Modal from "../../Atoms/Modals/Modal";
import { sendCPLog } from "../../../Utils/Log/CPlog";
import BlackBtnB from "../../Atoms/Buttons/BlackBtnB";
import {
  grayScale,
  mCaption1,
  mHeader2,
  sparta,
} from "@teamsparta/design-system";
import styled from "@emotion/styled";
import { ResultNotice } from "../../Atoms/ResultNotice/ResultNotice";
import { BenefitNbc } from "../../molecules/Benefit/BenefitNbc";
import { BenefitNb } from "../../molecules/Benefit/BenefitNb";

const ResultContainer = styled.div`
  margin-top: 16px;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  h3 {
    flex-grow: 0;
    object-fit: contain;
    font-family: "Cafe24Ohsquare";
    font-size: 28px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: center;
    color: #000;
  }
`;

const Header = styled.div`
  background-color: white;
  padding: 16px 0 1px;

  h3 {
    height: 27px;
    flex-grow: 0;
    font-family: "Pretendard";
    font-size: 18px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: 0.05px;
    text-align: center;
    color: #000;

    b {
      width: 67px;
      height: 22px;
      flex-grow: 0;
      font-family: "Cafe24Ohsquare";
      font-size: 19px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: normal;
      text-align: center;
      color: #000;
      vertical-align: text-bottom;
    }
  }
`;

const BtnContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  margin-top: 80px;
`;

export default () => {
  const { state } = useLocation();

  let result = state?.result;
  const logObj = state?.logObj;
  const jobStatus = logObj.current["현재 나는,"];
  const isNbcFit = ["student", "jobSeeker"].includes(jobStatus);
  const navigate = useNavigate();
  const [modalVisible, setModalVisible] = useState(0);
  const toggleModal = () => setModalVisible([1, 0][modalVisible]);

  useEffect(() => {
    if (result === undefined) {
      navigate("/nb/selection");
    }

    sendCPLog("nb_quiz_response", logObj);
  }, []);

  return (
    <Wrapper shown={1}>
      <Header>
        <h3>
          <b>국카찬스</b>
          &nbsp;조회결과
        </h3>
      </Header>
      <ResultContainer shown={1}>
        <AccountContainer>
          <AccoutTitle>나의 국비지원 계좌 한도는?</AccoutTitle>
          <LimitAmount>{result},000,000 원</LimitAmount>
          <ResultNotice />
        </AccountContainer>
        <BenefitContainer>
          {isNbcFit ? <BenefitNbc /> : <BenefitNb />}

          <BtnContainer className="btn-container">
            <CopyToClipboard
              text={"https://nbquiz.spartacodingclub.kr/nb"}
              onCopy={toggleModal}
            >
              <BlackBtnB
                onClick={() => {
                  sendCPLog("nb_quiz_click_button", {
                    button_text: "친구에게 알려주기",
                  });
                }}
              >
                친구에게 알려주기
              </BlackBtnB>
            </CopyToClipboard>
            <WhiteBtnB onClick={() => navigate("/nb/selection")}>
              퀴즈 다시 해보기
            </WhiteBtnB>
          </BtnContainer>
          {isNbcFit && (
            <NbcNoticeContainer>
              <NbcNotice>
                국민내일배움카드 발급 시, 국비지원으로 최대 500만원까지 교육
                과정을 수강할 수 있습니다. (개인마다 계좌 한도 금액은
                상이합니다.)
              </NbcNotice>
              <NbcNotice>
                K-디지털 트레이닝은 약 2천만원의 교육비 지원과 함께 매월
                31만원의 훈련지원금이 지급되는 디지털 핵심 인재 양성 과정입니다.
              </NbcNotice>
            </NbcNoticeContainer>
          )}
        </BenefitContainer>
      </ResultContainer>
      <Modal toggle={toggleModal} open={modalVisible}>
        <ResultModal>
          링크가 복사되었습니다! <br />
          지금 바로, 친구에게 알려줍시다!
        </ResultModal>
      </Modal>
    </Wrapper>
  );
};

const AccountContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 40px 0px;
  width: 328px;
  height: 100%;

  background: #ffffff;
`;

const AccoutTitle = styled.p`
  ${mHeader2};
  margin-bottom: 8px;
`;

const LimitAmount = styled.p`
  font-family: "Cafe24Ohsquare";
  font-style: normal;
  font-weight: 700;
  font-size: 30px;
  line-height: 140%;
  color: ${sparta.red100};
  margin-bottom: 20px;
`;

const Wrapper = styled.div`
  ${({ shown }) =>
    shown ? `background-color: #fff;` : `background-color: #eef9d9;`}
  min-height: 100vh;
`;

const ResultModal = styled.div`
  height: 100px;
  width: 320px;
  background-color: white;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 8px;

  flex-grow: 0;
  font-family: "Pretendard";
  font-size: 15px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: 0.04px;
  text-align: center;
  color: #000;
`;

const BenefitContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px 23px;

  width: 100%;
  height: 100%;

  background: #fff6f8;
`;

const NbcNoticeContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding-left: 20px;

  position: relative;

  width: 329px;
  height: 90px;

  margin-top: 20px;
`;

const NbcNotice = styled.div`
  ${mCaption1};
  color: ${grayScale.gray70};
  width: 100%;
  text-align: left;

  &::before {
    content: "•";
    display: inline-block;
    font-size: 20px;

    position: absolute;
    left: 3px;
  }
`;
